import { useQuery } from '@tanstack/react-query';
import { Services } from './services';

export const useAccountInformation = () => {
	return useQuery(['account-information'], () => Services.getCustomerInformation());
};
